import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const OrderModule = {
  namespaced : true,
  state      : {
    //- Selected Order
    order: null,
  },
  getters,
  actions,
  mutations
}

export default OrderModule